import React, { forwardRef } from 'react'
import { ViewPropTypes, View, ScrollView } from 'react-native'
import PropTypes from 'prop-types'

import VfText from '../VfText'

import styles from './Timeline.Styles'

const Timeline = forwardRef((props, ref) => {

  const {
    items,
    direction,
    titleStyle,
    activeTitleStyle,
    descStyle,
    activeDescStyle,
    titleProps,
    descProps,
    style,
    iconContainerStyle,
    isContentLoading,
    theme,
  } = props

  const { length: len } = items

  const customStyles = {
    title: {
      active: {},
      current: activeTitleStyle,
      inactive: {},
    },
    desc: {
      active: {},
      current: activeDescStyle,
      inactive: {},
    },
  }

  return (
    <ScrollView
      ref={curRef => { ref.current = curRef }}
      contentContainerStyle={[styles['wraper_' + direction], style]}
      horizontal={direction === 'horizontal'}
      showsHorizontalScrollIndicator={false}
    >
      {items.map((item, i) => (
        <View style={styles['container_' + direction]} key={i}>
          <View style={[styles.iconsContainer, iconContainerStyle]}>
            <View
              style={
                i !== len - 1
                  ? [
                    styles['line_' + direction],
                    styles['line_' + item.type](theme),
                  ]
                  : []
              }
            />
            <View style={[styles.outer, styles['outer_' + item.type](theme)]}>
              <View style={[styles.inner, styles['inner_' + item.type](theme)]} />
            </View>
          </View>
          <View style={styles['text_container_' + direction]}>
            <VfText
              size="h5"
              style={[
                styles.title,
                styles['title_' + direction + '_' + item.type],
                titleStyle,
                customStyles.title[item.type],
                isContentLoading && { width: 50 }
              ]}
              isLoading={isContentLoading}
              i18nKey={item.title}
              color={theme.colors.textColorTwo}
              loadingBackgroundColor={theme.colors.shimmerCenterColor}
              loadingForegroundColor={theme.colors.shimmerEdgesColor}
              {...titleProps}
            />
            {item.desc && (
              <VfText
                weight="light"
                style={[
                  styles.desc,
                  styles['desc_' + direction],
                  styles['desc_' + direction + '_' + item.type],
                  descStyle.
                    customStyles.desc[item.type]
                ]}
                isLoading={isContentLoading}
                i18nKey={item.desc}
                {...descProps}
              />
            )}
          </View>
        </View>
      ))}
    </ScrollView>
  )
})

Timeline.defaultProps = {
  direction: 'vertical'
}

Timeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['active', 'current', 'inactive']),
      title: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
  titleStyle: PropTypes.object,
  activeTitleStyle: PropTypes.object,
  descStyle: PropTypes.object,
  activeDescStyle: PropTypes.object,
  style: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style)
  ]),
  titleProps: PropTypes.object,
  descProps: PropTypes.object,
  iconContainerStyle: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style)
  ]),
  isContentLoading: PropTypes.bool
}

export default Timeline
